/*
 *
 * Artifactory is a binaries repository manager.
 * Copyright (C) 2018 JFrog Ltd.
 *
 * Artifactory is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 *  (at your option) any later version.
 *
 * Artifactory is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with Artifactory.  If not, see <http://www.gnu.org/licenses/>.
 *
 */
// For debugging only:
window._aolSimulate = function (value) {
    localStorage._aol = value ? "true" : "false";
}
window._aolOff = function () {
    delete localStorage._aol;
}
window._licenseSimulate = function (value) {
    localStorage._license = value;
}
window._licenseOff = function () {
    delete localStorage._license;
}

// Service for accessing allowed features and licenses
export class ArtifactoryFeatures {
    constructor(FooterDao, ArtifactoryState, $location, $q, GoogleAnalytics) {
        this.footerDao = FooterDao;
        this.ArtifactoryState = ArtifactoryState;
        this.$location = $location;
        this.GoogleAnalytics = GoogleAnalytics;
        let defer = $q.defer();
        this.whenReady = defer.promise;
        this.footerDao.get().then(() => {
            this.GoogleAnalytics._setUpGA();
            defer.resolve();
        });
        this.FEATURES = this.getFeatures();
    }

    getAllowedLicense(feature) {
        return window.store.getters['common/artifactory/GET_FEATURE_ALLOWED_LICENSE'](feature);
    }

    isEnabled(feature) {
        return window.store.getters['common/artifactory/IS_FEATURE_ENABLED'](feature);
    }

    isDisabled(feature) {
        return !this.isEnabled(feature);
    }

    isHidden(feature) {
        return window.store.getters['common/artifactory/IS_FEATURE_HIDDEN'](feature);
    }

    isVisible(feature) {
        return !this.isHidden(feature);
    }

    isAol() {
        if (localStorage._aol != undefined) {
            return localStorage._aol === "true";
        } // For debugging only
        return window.store.getters['common/context/GET_IS_CLOUD'];
    }

    isDedicatedAol() {
        return  window.store.getters['common/context/GET_IS_DEDICATED'];
    }

    getInstalledLicense() {
        return window.store.getters['common/context/GET_LICENSE_TYPE'];
    }

    isCloudProviderConfigured(){
        return window.store.getters['common/context/HAS_CLOUD_PROVIDER'];
    }

    getCurrentLicense() {
        return this.getInstalledLicense().name;
    }

    isEdge() {
        return window.store.getters['common/context/IS_EDGE_NODE'];
    }

    isOss() {
        return window.store.getters['common/context/IS_OSS'];
    }

    isEnterprisePlus() {
        return window.store.getters['common/context/IS_ENT_PLUS'];
    }

    isEnterprise() {
        return window.store.getters['common/context/IS_ENT'];
    }

	isEdgeNode() {
		return window.store.getters['common/context/IS_EDGE_NODE'];
    }

    isConanCE() {
        return window.store.getters['common/context/IS_CONAN'];
    }

    isJCR() {
        return window.store.getters['common/context/IS_JCR'];
    }

    isNonCommercial() {
        return window.store.getters['common/context/IS_FREEMIUM_EDITION'];
    }

    getFeatures() {
        return window.store.getters['common/artifactory/GET_ARTIFACTORY_FEATURES'];
    }

    getFeatureName(feature = '') {
        return this.FEATURES[feature.toLowerCase()].label;
    }

    getFeatureLink(feature = '') {
        const featureName = feature.toLowerCase();
        if (this.FEATURES[featureName] && this.FEATURES[featureName].path) {
            return `http://service.jfrog.org/artifactory/addons/info/${ this.FEATURES[featureName].path }`;
        }
    }

    sortPackageTypesByVisibility(pkgTypes, visibilityProps, toFilter) {
        const { available, unavailable } = window.store
            .getters['common/artifactory/GET_PACKAGE_TYPES_SORTED_BY_VISIBILITY'](pkgTypes, visibilityProps, toFilter);
        let concatinatedList = available.concat(unavailable);
        const bowerRepo = concatinatedList.find(type => type.value === 'bower');
        if(bowerRepo){
            concatinatedList = concatinatedList.filter(type => type.value !== 'bower');
            concatinatedList.push(bowerRepo);
        }
        return concatinatedList;
    }

    getJcrRepos() {
        return window.store.getters['common/artifactory/GET_JCR_REPOS'];
    }

    getOssRepos() {
        return window.store.getters['common/artifactory/GET_OSS_REPOS'];
    }

    getConanRepos() {
        return window.store.getters['common/artifactory/GET_CONAN_REPOS'];
    }
}



// WEBPACK FOOTER //
// ./services/artifactory_features.js